// lib/market/uiConfigDefaults.ts
//
// Miroir exact de la valeur DEFAULT de market_shops.ui_config côté SQL
// (voir market_schema_patch_v5.sql). Sert de fallback frontend si jamais
// une boutique arrive sans ui_config, et de base pour le formulaire de
// l'écran Réglages.
//
// IMPORTANT : garder ce fichier synchronisé manuellement avec le DEFAULT
// SQL à chaque futur patch de palette/structure.

type ThemeMode = 'light' | 'dark' | 'auto';

type ShopColors = {
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  card: string;
  button: string;
  border: string;
  text: string;
  link: string;
};

type ShopTypography = {
  font_family: 'inter' | 'roboto' | 'poppins' | 'system';
  heading_size: 'sm' | 'md' | 'lg' | 'xl';
  text_size: 'sm' | 'md' | 'lg' | 'xl';
  heading_weight: 'normal' | 'medium' | 'bold';
};

type ShopLayout = {
  display_mode: 'grid' | 'list';
  grid_columns: number;
  card_spacing: 'sm' | 'md' | 'lg';
  border_radius: 'none' | 'sm' | 'md' | 'lg' | 'full';
  shadows: boolean;
  max_width: 'sm' | 'md' | 'lg' | 'xl' | 'full';
};

type ShopHeaderConfig = {
  show_tagline: boolean;
  show_description: boolean;
  show_phone: boolean;
  show_whatsapp_business: boolean;
  show_address: boolean;
  show_email: boolean;
};

type ShopProductsConfig = {
  card_size: 'sm' | 'md' | 'lg';
  show_price: boolean;
  show_stock: boolean;
  show_action_buttons: boolean;
  show_badges: boolean;
};

type ShopUiConfig = {
  theme_mode: ThemeMode;
  colors: ShopColors;
  typography: ShopTypography;
  layout: ShopLayout;
  header: ShopHeaderConfig;
  products: ShopProductsConfig;
};

// TODO: recopier ici exactement les valeurs du DEFAULT SQL (V5)
const DEFAULT_SHOP_UI_CONFIG: ShopUiConfig = {
  theme_mode: 'auto',
  colors: {
    primary: '#6610B1',
    secondary: '#6B7280',
    accent: '#C9A84C',
    background: '#FFFFFF',
    card: '#F9FAFB',
    button: '#6610B1',
    border: '#E5E7EB',
    text: '#111827',
    link: '#6610B1',
  },
  typography: {
    font_family: 'inter',
    heading_size: 'lg',
    text_size: 'md',
    heading_weight: 'bold',
  },
  layout: {
    display_mode: 'grid',
    grid_columns: 2,
    card_spacing: 'md',
    border_radius: 'md',
    shadows: true,
    max_width: 'lg',
  },
  header: {
    show_tagline: true,
    show_description: true,
    show_phone: true,
    show_whatsapp_business: true,
    show_address: false,
    show_email: false,
  },
  products: {
    card_size: 'md',
    show_price: true,
    show_stock: true,
    show_action_buttons: true,
    show_badges: true,
  },
};

export { DEFAULT_SHOP_UI_CONFIG };
export type {
  ShopUiConfig,
  ThemeMode,
  ShopColors,
  ShopTypography,
  ShopLayout,
  ShopHeaderConfig,
  ShopProductsConfig,
};
